import { Injectable } from "@angular/core";
import { Observable, tap } from "rxjs";
import { EmployeeEventType } from "@gtmhub/employees/services/events";
import { IBulkActionOnUsersResponse } from "@gtmhub/users";
import { RequestConfig } from "@webapp/core/abstracts/models/request-config.model";
import { RequestPaging } from "@webapp/core/abstracts/models/request.paging";
import { BaseFacade } from "@webapp/core/abstracts/services/base-facade.service";
import { BroadcastService } from "@webapp/core/broadcast/services/broadcast.service";
import { ICollection } from "@webapp/core/root/models/root.models";
import { IUsersLimit, User, UsersDTO } from "../models/users.models";
import { UsersApiService } from "./users-api.service";
import { UsersState } from "./users-state.service";

@Injectable({
  providedIn: "any",
})
export class UsersFacade extends BaseFacade<User, UsersDTO, UsersState, UsersApiService> {
  public constructor(state: UsersState, api: UsersApiService, private broadcastService: BroadcastService) {
    super(state, api);
  }

  public getUsersV2$(filter?: RequestPaging): Observable<ICollection<User>> {
    return this.apiService.getAll$<ICollection<User>>(filter, { ...new RequestConfig(), url: this.apiService.getUsersV2Endpoint() });
  }

  public activateUser$(user: Partial<User>): Observable<IBulkActionOnUsersResponse> {
    return this.post$([user.id], {
      ...new RequestConfig(),
      url: this.apiService.getActivateUsersEndpoint(),
    });
  }

  public deactivateUser$(user: Partial<User>): Observable<IBulkActionOnUsersResponse> {
    return this.post$([user.id], {
      ...new RequestConfig(),
      url: this.apiService.getDeactivateUsersEndpoint(),
    });
  }

  public deleteUser$(user: Partial<User>): Observable<IBulkActionOnUsersResponse> {
    return this.post$<IBulkActionOnUsersResponse>([user.id], {
      ...new RequestConfig(),
      url: this.apiService.getDeleteUsersEndpoint(),
    }).pipe(
      tap(() => {
        this.broadcastService.emit(EmployeeEventType.EMPLOYEE_DELETED, { id: user.id });
      })
    );
  }

  public getUsersLimit$(addingUsersCount: number): Observable<IUsersLimit> {
    return this.get$(null, {
      ...new RequestConfig(),
      url: this.apiService.getUsersLimitEndpoint(),
      queryParams: { addingUsersCount },
    });
  }
}
